import React, {Component} from 'react';
import {Elements, StripeProvider} from 'react-stripe-elements';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import Modal from 'react-modal';
import CheckoutForm from './CheckoutForm';
import '../../../styles/css/stripeForm.scss';

const STRIPE_KEY = 'pk_live_UReoeAo2BIUuxNctrURMq1Vu';// 'pk_live_UReoeAo2BIUuxNctrURMq1Vu' 'pk_test_1ELMwIhfvhHe6vf0qqZXFbvK';

@inject('workshopDetails')
@inject('user')
export default class StripeForm extends Component {
  state = {
    showForm: false,
  }

  hideStripeModal = () => {
    this.setState({showForm: false});
  }

  renderPurchaseButton = () => {
    const {workshopDetails} = this.props;
    const {workshop} = workshopDetails || {};
    if (workshop.workshop_state === "confirmed_workshop" && (workshop.workshop_type === 'live' && moment(workshop.end_date).add(moment(workshop.end_time).hours(), 'hours').isAfter(moment()))) {
      return (
        <div
          onClick={() =>this.setState({showForm: true})}
          className="workshop-creator-sidebar-publish"
          style={{
            marginTop: 10,
            marginBottom: 10
          }}
        >
          <span className="btn prime bordered" style={{ padding: 15 }}>PURCHASE</span>
        </div>
      );
    } else if (workshop.workshop_state === "confirmed_workshop" && workshop.workshop_type !== 'live') {
      return (
        <div
          onClick={() =>this.setState({showForm: true})}
          className="workshop-creator-sidebar-publish"
          style={{
            marginTop: 10,
            marginBottom: 10
          }}
        >
          <span className="btn prime bordered" style={{ padding: 15 }}>PURCHASE</span>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const {workshopDetails, user} = this.props;
    const currentUser = user.getUser();
    const cost = parseFloat(workshopDetails.workshop.cost) * 100
    return workshopDetails.workshop.status === null || workshopDetails.workshop.status === 'failed' ? (//|| workshopDetails.workshop.access_type === 'not_purchased' ? (
      <div>
        {this.state.showForm ? (
          <StripeProvider apiKey={STRIPE_KEY}>
            <Elements>
              <Modal
                isOpen={this.state.showForm}
                closeTimeoutMS={100}
                contentLabel="Modal"
                shouldCloseOnOverlayClick={true}
              >
                <div className='stripe-header'>
                  <div className='bordered-line' />
                  <h1>{currentUser.email}</h1>
                </div>
                <CheckoutForm
                  user={currentUser}
                  cost={cost}
                  hideStripeModal={this.hideStripeModal}
                />
              </Modal>
              </Elements>
            </StripeProvider>
          ) : this.renderPurchaseButton()
        }
      </div>
    ) : (
      <div className="workshop-creator-sidebar-publish" style={{
        marginTop: 10,
        marginBottom: 10
      }}>
        <span className="btn prime bordered" style={{ padding: 15 }} onClick={this.stopClick}>TRANSACTION PENDING</span>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/StripeForm.jsx